'use strict';

import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './home.routes';
//import ftscroller from '../../../components/util/scroller';
import 'ngmap';

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export class HomeController 
{
	/*@ngInject*/
	constructor(Auth, $http, $scope, $ocLazyLoad, NgMap) 
	{
		this.$http = $http;
		this.$scope = $scope;
		this.$scope.getCurrentUser = Auth.getCurrentUserSync;
		this.$scope.googleMapsUrl = "https://maps.google.com/maps/api/js?key=AIzaSyDBkv9Ixw7hJUVvyU0N_jrfDF5jVAx4tx0";

		this.$scope.LiveLink = function(eventid, version)
		{
			if (version <= 1)
				return "https://live.everlaps.com/" + eventid;
			else
				return "https://live" + version + ".everlaps.com/" + eventid;
		}

		NgMap.getMap().then(map => {
			this.map = map;
			if ($scope.previousEvents)
				this.FillData();
		})
		.catch(err => {
			console.log("GoogleMap load failed");
		});
	}

	CreateMarker(e, color)
	{
		let marker = new google.maps.Marker({
			position: new google.maps.LatLng(e.lat, e.lon),
			icon: {
				path: google.maps.SymbolPath.CIRCLE,
				fillOpacity: 0.5,
				fillColor: color,
				strokeOpacity: 1.0,
				strokeColor: 'black',
				strokeWeight: 1.5, 
				scale: 6 //pixels
			},
			map: this.map
		});

		let infoWindow = new google.maps.InfoWindow({
			content:
			// <h1 id="firstHeading" class="firstHeading">${e.title}</h1>
			`<div id="content">
				<div id="siteNotice" style="text-transform:uppercase;font-size:12px">${e.track}</div>
				<div id="bodyContent">
					<a style="text-transform:uppercase;font-size:11px" href="/ev/${e.eventid}">${e.title}</a>
				</div>
			</div>`
			//maxWidth: 250
		});

		marker.addListener('click', () =>
		{
			if (this.infoWindow) this.infoWindow.close();
			this.infoWindow = infoWindow;
			this.infoWindow.open(this.map, marker);
		});
	}

	FillData()
	{
		try
		{
			var cl = this.$scope.currentEvents.length;
			var nl = this.$scope.nextEvents.length;
			var pl = this.$scope.previousEvents.length;

			google.maps.event.addListener(this.map, 'click', () =>
			{
				if (this.infoWindow) 
				{
					this.infoWindow.close();
					this.infoWindow = null;
				}
			});

			var tracks = [];

			for (let i = 0; i < cl; ++i) {
				let event = this.$scope.currentEvents[i];
				this.CreateMarker(event, 'orangered');
				tracks.push(event.trackid);
			}

			for (let i = 0; i < nl; ++i) {
				let event = this.$scope.nextEvents[i];
				if (tracks.indexOf(event.trackid) === -1)
				{
					this.CreateMarker(event, '#74DF00');
					tracks.push(event.trackid);
				}
			}

			for (let i = 0; i < pl; ++i) 
			{
				let event = this.$scope.previousEvents[i];
				if (tracks.indexOf(event.trackid) === -1)
				{
					this.CreateMarker(event, '#2196F3');
					tracks.push(event.trackid);
				}
			}

			/*
			// Llamar en orden inverso a prioridad
			for (let i = 0; i < pl; ++i) 
			{
				this.CreateMarker(this.$scope.previousEvents[i], '#2196F3');
			}

			for (let i = 0; i < nl; ++i) {
				this.CreateMarker(this.$scope.nextEvents[i], '#74DF00');
			}

			for (let i = 0; i < cl; ++i) {
				this.CreateMarker(this.$scope.currentEvents[i], 'orangered');
			}
			*/
		}
		catch (err)
		{
			console.log("Something failed with GoogleMaps");
		}
	}

	$onInit() {
		//console.log("main:OnInit");

		this.$http.post("/api/frontend/events/home-events")
		.then(response =>
		{
			this.$scope.currentEvents = response.data.currentEvents;
			this.$scope.nextEvents = response.data.nextEvents;
			this.$scope.previousEvents = response.data.previousEvents;

			if (this.map)
				this.FillData();
		});
	}
}

export default angular.module('everlaps.main', [uiRouter, 'ngMap', /*'ng-ftscroller'*/])
	.config(routing)
	.component('main', {
		template: require('./home.html'),
		controller: HomeController
	})
	.name;



// WEBPACK FOOTER //
// ./client/app/frontend/home/home.component.js